"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
const types_1 = require("../types");
function toConsoleFunction(logLevel) {
    switch (logLevel) {
        case types_1.LogLevel.Error:
            return console.error;
        case types_1.LogLevel.Warn:
            return console.warn;
        case types_1.LogLevel.Info:
            return console.info;
        case types_1.LogLevel.Debug:
            return console.debug;
        default: {
            const neverLevel = logLevel;
            throw new Error(`Unknown log level: ${neverLevel}`);
        }
    }
}
exports.default = toConsoleFunction;
//# sourceMappingURL=toConsoleFunction.js.map